export const themeColor = (user: { [key: string]: any }) => {
  const getCurrentTheme = () => {
    let theme;

    user.theme
      ? (theme = user.theme)
      : (theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    return theme;
  };

  let themeColor = getCurrentTheme();
  document.documentElement.setAttribute("color-theme", themeColor);

  const root = document.documentElement;
  user.theme_color_hs && root.style.setProperty("--h", user.theme_color_hs);
};
